import type { FaqSurface } from "./types";

/**
 * Named surface presets — ordered catalog entry ids.
 * - `homepage` — HomepageFaqSection (Phase 2); no parallel Q&A in homepage/copy
 * - `help_fab_*` — Help FAB sheet (Phase 3)
 */
export const FAQ_SURFACE_PRESETS: Record<FaqSurface, readonly string[]> = {
  /** D5: protect-buyers-sellers → how-payments-work → item-not-as-described */
  homepage: [
    "protect-buyers-sellers",
    "how-payments-work",
    "item-not-as-described",
  ],
  help_fab: [
    "protect-buyers-sellers",
    "how-payments-work",
    "item-not-as-described",
    "after-payment",
    "arrange-pickup",
  ],
  help_fab_buy: [
    "after-payment",
    "arrange-pickup",
    "item-not-as-described",
    "how-payments-work",
    "protect-buyers-sellers",
  ],
  help_fab_sell: [
    "protect-buyers-sellers",
    "how-payments-work",
    "item-not-as-described",
    "when-sellers-get-paid",
    "listing-approval-criteria",
  ],
};
